module.exports = __webpack_public_path__ + "img/timg.0661a4aa.gif";